import { ReactNode } from 'react';

import {
  Button,
  ButtonTypes,
  Group,
  Input,
} from 'apps/shared/scripts/components';

import { useOnNextStep } from '../../hooks';
import Body from '../Body';
import Footer from '../Footer';
import Header from '../Header';
import Heading from '../Heading';
import Logo from '../Logo';
import { ChildrenProps, FormValues } from '../OnboardingForm';
import Subheading from '../Subheading';

import { buttonMobileClassName } from './styles';

interface OwnProps {
  buttonLabel?: string;
  children?: ReactNode;
  enablePrev?: boolean;
  heading: string;
  isFinalStep?: boolean;
  isSubmitting?: boolean;
  name: keyof FormValues;
  onNext: () => void;
  onPrev: () => void;
  percentage: number;
  subheading: string;
}

export type Props = Omit<ChildrenProps, 'formValues'> & OwnProps;

const Step = ({
  buttonLabel,
  children,
  clearErrors,
  control,
  enablePrev,
  errors,
  heading,
  isFinalStep,
  isSubmitting,
  name,
  onNext,
  onPrev,
  percentage,
  subheading,
  trigger,
}: Props) => {
  const { onClick, onKeyDown } = useOnNextStep({
    clearErrors,
    name,
    onNext,
    trigger,
  });
  return (
    <>
      <Logo />
      <Header>
        <Heading>{heading}</Heading>
        <Subheading>{subheading}</Subheading>
      </Header>
      <Body>
        {children ?? (
          <Group errors={errors} validate={name}>
            <Input control={control} name={name} onKeyDown={onKeyDown} />
          </Group>
        )}
      </Body>
      <Footer percentage={percentage}>
        {enablePrev && (
          <Button
            className={buttonMobileClassName}
            onClick={onPrev}
            loading={isSubmitting}
            type={ButtonTypes.Button}
          >
            {'Back'}
          </Button>
        )}
        <Button
          primary
          onClick={onClick}
          disabled={isSubmitting}
          loading={isSubmitting}
          type={isFinalStep ? ButtonTypes.Submit : ButtonTypes.Button}
        >
          {buttonLabel ?? 'Continue'}
        </Button>
      </Footer>
    </>
  );
};

Step.displayName = 'Step';

export default Step;
